import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=12a450ad&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"
import style0 from "./Signup.scss?vue&type=style&index=0&id=12a450ad&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a450ad",
  null
  
)

export default component.exports